 <template>
  <el-row
    class="pageSize"
    style="margin: 0 auto; padding-top: 15px;"
  >

    <Head homeTitle="组合风险评价"></Head>
    <el-row>
      <el-col
        :span="1"
        class="line_border_bottom el-tabs__item"
      >
      </el-col>
      <el-col :span="23">
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="ReloadTab"
        >
          <el-tab-pane
            label="组合风险评价"
            name="first"
          >
            <PortfolioRisk ref="portfolioRisk"></PortfolioRisk>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

  </el-row>
</template>
<script>
import PortfolioRisk from "../../components/main/PortfolioRisk";
const componentsCommon=require("cb-components-common").default;
let Head = componentsCommon.Head;
export default {
    data() {
        return {
            activeName: "first",
        };
    },
    components: { Head, PortfolioRisk },
    watch: {
        activeName: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.$refs.portfolioRisk.initData();
                    break;
            }
        },
    },
    methods: {
        ReloadTab(para) {
            let self = this;
            if (para.name == "first") {
                self.$refs.portfolioRisk.initData();
            }
        },
    },
};
</script>